<template>
  <b-modal id="modal-request-approval" ref="modal" size="lg" title="Compensatory Overtime" @show="setData" :hide-footer="hideButton">
    <b-form >
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <legend><em class="fa fa-calendar"></em> Compensation day Request</legend>
              <div class="form-row">
                <label class="col-md-3">Employee</label>
                <div class="col-md-6 mb-3">
                  {{detail.emp_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Transaction Number</label>
                <div class="col-md-6 mb-3">
                  {{detail.number}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Leave Date</label>
                <div class="col-8 mb-3">
                  <div class="row">
                    <div class="col-sm-5 mb-1">
                      Date
                    </div>
                    <div class="col-sm-4 mb-1">
                      Time
                    </div>
                    <template  v-for="(item, i) in items">
                      <div class="col-sm-5 mb-1">
                        {{item.date}}
                      </div>
                      <div class="col-sm-4 mb-1">
                        {{item.hours}}
                      </div>
                    </template>

                  </div>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Project</label>
                <div class="col-md-6 mb-3">
                  {{detail.project_abbreviation}} - {{detail.var_name}}
                </div>
              </div>

              <div class="form-row">
                <label class="col-md-3">Note</label>
                <div class="col-md-6 mb-3">
                  {{detail.reason}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">PIC when leave</label>
                <div class="col-md-6 mb-3">
                  {{detail.contact_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Status</label>
                <div class="col-md-6 mb-3">
                  {{detail.comp_stat_name}}
                </div>
              </div>
              <hr/>
              <legend><em class="fa fa-users"></em> Approval Information</legend>
              <list-supervisor-finish :list_supervisor="list_supervisor" v-if="!arr_status.includes(detail.comp_stat_id)"></list-supervisor-finish>
              <list-supervisor :emp_id="detail.emp_id.toString()" v-else></list-supervisor>
            </div>
          </div>
        </div>
      </div>
    </b-form>
    <template v-slot:modal-footer >
      <div class="w-100">
        <button class="btn btn-success float-right mr-1" @click="stat_id=3;handleOk($event)"> Approve </button>
        <button class="btn btn-danger float-right mr-1" @click="stat_id=5; handleOk($event)"> Reject </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {BModal, BForm} from "bootstrap-vue";
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";
import ListSupervisor from "../employee/ListSupervisor";
import ListSupervisorFinish from "../employee/ListSupervisorFinish";

export default {
  name: "CompensatoryApproval",
  components:{ListSupervisorFinish, ListSupervisor, BModal, BForm},
  props:{
    data:{
      type:Object
    }
  },
  data(){
    return {
      hideButton:true,
      detail:{},
      items:[],
      list_supervisor:[],
      arr_status:[0]
    }
  },
  methods:{
    handleOk(evt){
      evt.preventDefault()
      let payload = {
        stat_id:this.stat_id,
        emp_id:this.$store.getters.empId,
        trans_id:this.data.trans_id,
        master_id:this.data.master_id,
        log_id:this.data.id
      }

      AxiosCall.Post(payload, urlApi.compensatory.approval).then(res=>{
        if(res.success){
          this.$root.$children[0].successMessage(res.message)
          this.$refs.modal.hide()
          this.$parent.getData()
        }else{
          this.$root.$children[0].errorMessage(res.message)
        }
      }).catch(e=>{
        this.$root.$children[0].errorMessage(e.response.data.message)
      })
    },
    setData(){
      setTimeout(()=>{
        this.getDetail()
      }, 100)
    },
    getDetail(){
      let payload = {
        id:this.data.master_id
      }
      AxiosCall.Get(payload, urlApi.compensatory.detail).then(res=>{
        if (res.success){
          this.detail = res.atributes
          this.items = JSON.parse(res.atributes.items)
          this.hideButton =  (this.detail.emp_id == this.$store.getters.empId) ? true :false
          if(!this.arr_status.includes(res.atributes.comp_stat_id)) this.getListSupervisor()
        }else{
          this.$root.$children[0].errorMessage(res.message)
        }
      }).catch(e=>{
        console.log(e)
        this.$root.$children[0].errorMessage(e.response.data.message)
      })
    },
    getListSupervisor(){
      let payload = {
        id:this.data.master_id
      }
      AxiosCall.Get(payload, urlApi.compensatory.status).then(res=>{
        if(res.success){
          this.list_supervisor = res.atributes
        }else {
          this.$root.$children[0].errorMessage(res.message)
        }
      }).catch(e=>{
        this.$root.$children[0].errorMessage(e.response.data.message)
      })
    }
  }
}
</script>